/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-lonely-if */
/* eslint-disable no-console */
import axios from 'axios';
import { showToast } from './toastService';

const api = axios.create({
  baseURL: process.env.REACT_APP_APIURL,
});

let isTokenInvalid = false;

const handleExpiredSession = () => {
  if (isTokenInvalid) {
    return;
  }

  isTokenInvalid = true;

  showToast({
    type: 'error',
    title: 'Sessão expirada',
    description: 'Por favor, realize o login novamente.',
  });

  localStorage.removeItem('@Transfacil:token');
  localStorage.removeItem('@Transfacil:user');

  setTimeout(() => {
    window.location.href = '/';
  }, 2000);
};

api.interceptors.response.use(
  response => response,
  error => {
    console.log({
      url: error?.config?.url,
      status: error?.response?.status,
      data: error?.response?.data,
    });

    const statusCode = error?.response?.status;
    const detail = error?.response?.data?.detail;
    const message = error?.response?.data?.message;

    const isInvalidToken =
      detail === 'Token inválido.' ||
      detail === 'Token expirado.' ||
      message === 'Token inválido.' ||
      message === 'Token expirado.';

    if ((statusCode === 401 || statusCode === 403) && isInvalidToken) {
      handleExpiredSession();
    }

    return Promise.reject(error);
  },
);

export default api;
